import { ref } from 'vue';

export interface ConfirmOptions {
  title: string;
  message: string;
  details?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

interface ConfirmState extends ConfirmOptions {
  resolve: (v: boolean) => void;
}

const state = ref<ConfirmState | null>(null);

export function useConfirm() {
  function confirm(opts: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
      state.value = { ...opts, resolve };
    });
  }
  function answer(v: boolean): void {
    if (state.value) {
      state.value.resolve(v);
      state.value = null;
    }
  }
  return { state, confirm, answer };
}
